import React, { Component } from 'react';
import NavBar from '../../components/NavBar/NavBar';
import SideBar from './../../components/SideBar/SideBar';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import './ManagerHome.css';
import AddToolkit from '../../pages/toolkit/AddToolkit';
import EditToolkit from '../../pages/toolkit/EditToolkit';
import ToolDetails from '../../pages/toolkit/ToolDetails/Details/ToolDetails';
// import ViewToolkit from '../../pages/toolkit/ViewToolkit';
import ChooseToolkitCategory from '../../pages/toolkit/ChooseToolkitCategory';
import ToolkitCategory from '../../pages/toolkit/ToolkitCategory';
import ToolPreview from '../../pages/toolkit/ToolDetails/Preview/Preview';
import ChooseAnalyticsCategory from '../../pages/analytics/ChooseCategory/ChooseAnalyticsCategory';
import CreateChart from '../../pages/analytics/CreateChart/CreateChart';
import EditChart from '../../pages/analytics/EditChart/EditChart';
import ChartList from '../../pages/analytics/ChartList/ChartList';
import OfficeMates from '../../pages/office/OfficeMates/OfficeMates';


class ManagerHome extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  handleToolkitCategoryClicked = (category) => {
        // console.log(category);
  } 
  render() { 
    return ( 
      <div>
        <NavBar {...this.props}/>
        {/* pb150 */}
        <div className="container-fluid mt62 ">
            <div className="row">
            <SideBar {...this.props} />
            <main role="main" className="col-md-9 col-md-offset-right-1 ml-sm-auto 
            col-lg-9 col-lg-offset-right-1 pt-3 px-4 col-sm-offset-right-1">
              <Switch>
                <Route exact path={this.props.match.url + '/my-activity'} render={() => <div>Dashboard</div>}/>
                <Route exact path={this.props.match.url + '/news'} render={() => <div>News</div>}/>
                <Route exact path={this.props.match.url + '/office/office-mates'} component={OfficeMates}/>
                <Route exact path={this.props.match.url + '/analytics/choose-category'} component={ChooseAnalyticsCategory}/>
                <Route exact path={this.props.match.url + '/analytics/create'} component={CreateChart}/>
                <Route exact path={this.props.match.url + '/analytics/edit'} component={EditChart}/>
                <Route exact path={this.props.match.url + '/analytics/:category'} component={ChartList}/>
                <Route exact path={this.props.match.url + '/toolkit/choose-category'} component={ChooseToolkitCategory}/>
                <Route exact path={this.props.match.url + '/toolkit/add'} component={AddToolkit}/>
                <Route exact path={this.props.match.url + '/toolkit/edit/:tool'} component={EditToolkit}/>
                <Route exact path={this.props.match.url + '/toolkit/tool/:id'} component={ToolDetails}/>
                <Route exact path={this.props.match.url + '/toolkit/preview'} component={ToolPreview}/>
                <Route exact path={this.props.match.url + '/toolkit/:category'} component={ToolkitCategory}/>
                <Redirect exact path={this.props.match.url} to={this.props.match.url + '/my-activity'}/>
              </Switch>
            </main>
          </div>
        </div>
      </div>
    )
  }
}
 
const mapStateToProps = state => {
	return {
    user: state.user.profile,
    toolkitCategories: state.toolkit.category,
    analyticsCategories: state.analytics.category
	};
};

const mapDispatchToProps = dispatch => {
	return {
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManagerHome));